import {useRoute} from '#app';

export default (errorLocation?: string) => {
  const { $sentryCaptureException } = useNuxtApp();
  const route = useRoute();
  const location = errorLocation || route.fullPath;

  $sentryCaptureException(new Error(`Site down error triggered from ${location}`), {level: 'fatal'});
};
